/*
  ============================================================
  carrinho.js — Helper de carrinho (add-to-cart via AJAX)
  ============================================================

  O QUE FAZ:
  Melhoria progressiva para adicionar produtos ao carrinho sem
  recarregar a pagina. Interceta o envio de qualquer formulario
  de add-to-cart, envia para a Cart AJAX API (/cart/add.js),
  atualiza contador e total no header ([data-cart-count],
  [data-cart-total]) e dispara eventos:
  - 'cart:added'   (detail = item adicionado)  -> modal de confirmacao
  - 'cart:updated' (detail = carrinho completo) -> barra de envio gratis

  OBSERVACOES:
  Funciona sem JS: o formulario de produto envia nativamente para
  /cart/add. Se o pedido AJAX falhar, o script faz fallback e submete
  o formulario da forma tradicional. Formato monetario e textos vem de
  window.themeStrings (layout/theme.liquid).
*/
(function () {
  var strings = window.themeStrings || {};

  function formatMoney(cents) {
    var format = strings.moneyFormat || '{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0];
    var decimals = parts[1];

    function group(str, sep) {
      return str.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }

    /* formatos sem decimais arredondam (como a Shopify), nao truncam */
    var rounded = String(Math.round(cents / 100));
    var formatted;
    if (format.indexOf('amount_no_decimals_with_comma_separator') !== -1) {
      formatted = group(rounded, '.');
    } else if (format.indexOf('amount_with_comma_separator') !== -1) {
      formatted = group(whole, '.') + ',' + decimals;
    } else if (format.indexOf('amount_no_decimals_with_space_separator') !== -1) {
      formatted = group(rounded, ' ');
    } else if (format.indexOf('amount_with_space_separator') !== -1) {
      formatted = group(whole, ' ') + ',' + decimals;
    } else if (format.indexOf('amount_with_apostrophe_separator') !== -1) {
      formatted = group(whole, "'") + '.' + decimals;
    } else if (format.indexOf('amount_no_decimals') !== -1) {
      formatted = group(rounded, ',');
    } else {
      formatted = group(whole, ',') + '.' + decimals;
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, formatted).replace(/<[^>]+>/g, '');
  }
  window.formatMoney = formatMoney;

  function updateCartUI(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0 && !el.hasAttribute('data-always');
    });
    document.querySelectorAll('[data-cart-total]').forEach(function (el) {
      el.textContent = formatMoney(cart.total_price);
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
  }

  function refreshCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(updateCartUI)
      .catch(function (err) {
        if (typeof window.dhReport === 'function') window.dhReport(err, { origem: 'cart.js' });
      });
  }
  window.refreshCart = refreshCart;

  function handleSubmit(event) {
    var form = event.target;
    if (!form.matches('form[action$="/cart/add"], form[data-type="add-to-cart-form"]')) return;

    event.preventDefault();
    var button = form.querySelector('[type="submit"], [name="add"]');
    if (button) button.setAttribute('aria-busy', 'true');
    if (window.dhProgress) window.dhProgress.start();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(
          function (body) {
            return { ok: r.ok, body: body };
          },
          function () {
            return { ok: r.ok, body: null };
          }
        );
      })
      .then(function (res) {
        if (!res.ok) {
          /* 422 = Shopify recusou (sem stock, variante indisponivel...): mostra a mensagem em vez da pagina de erro */
          var msg = (res.body && (res.body.description || res.body.message)) || strings.cartError || 'Error';
          if (typeof window.mostrarAlerta === 'function') window.mostrarAlerta(msg, 'negativo', 5000);
          else alert(msg);
          return;
        }
        var item = res.body;
        refreshCart();
        document.dispatchEvent(new CustomEvent('cart:added', { detail: item }));
        if (!document.querySelector('[data-cart-modal]') && typeof window.mostrarAlerta === 'function') {
          window.mostrarAlerta(strings.addedToCart || 'Producto añadido al carrito', 'positivo');
        }
      })
      .catch(function (err) {
        /* so sem rede/JS: envio nativo do formulario */
        if (typeof window.dhReport === 'function') window.dhReport(err, { origem: 'cart/add.js' });
        form.submit();
      })
      .finally(function () {
        if (button) button.removeAttribute('aria-busy');
        if (window.dhProgress) window.dhProgress.done();
      });
  }

  document.addEventListener('submit', handleSubmit);
  document.addEventListener('DOMContentLoaded', refreshCart);
})();
